<template>
  <div class="wrapper">
    <div class="head">
      <img :src="icon" />
      <span>{{title}}</span>
    </div>
    <div v-for="(item, index) in list" :key="index" :class="'block ' + 'block' + (index + 1)">
      <div v-if="index%2 == 0" class="block-box">
        <div class="block-img"><img :src="item.img" /></div>
        <div class="block-text">
          <div class="text-icon" v-if="index == 0">
            <img :src="icon" />
            <span>{{name}}</span>
          </div>
          <div class="text-box" v-html="item.text" />
        </div>
      </div>
      <div v-else class="block-box">
        <div class="block-text2" v-html="item.text" />
        <div class="block-img"><img :src="item.img" /></div>
      </div>
    </div>

    <div class="footer">
      <p>
        <a href="https://beian.miit.gov.cn/" target="_blank">{{copyright}}</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: '首页',
      icon: '',
      title: '首页',
      list: [],
    }
  },
  computed:{
    sdata() {
      return this.$store.state.data;
    }
  },
  created() {
    let data = this.sdata
    this.list = data.list
    this.name = data.name
    this.icon = data.icon
    this.copyright = data.copyright
    document.title = this.name
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  background: #fff;
  // 顶部导航栏
  .head {
    width: calc(100% - 1.5rem);
    padding: 0 .75rem;
    height: .5rem;
    background: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: .11rem;
    color: #333;
    box-shadow: .01rem .02rem .1rem 0 rgba(49,41,55,0.3);
    img {
      width: .3rem;
      height: .3rem;
      margin-right: .14rem;
    }
  }
  .block {
    display: flex;
    align-items: center;
    width: calc(100% - 1.5rem);
    padding: 0 .75rem;
    height: 5rem;
    .block-box {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      width: 100%;
    }
    .block-img {
      background: #FFFFFF;
      box-shadow: .05rem .05rem .15rem 0 rgba(49,41,55,0.19);
      border-radius: .15rem;
      width: 1.9rem;
      height: 3.4rem;
      padding: .08rem;
      img {
        width: 100%;
        height: 100%;
        border-radius: .11rem;
        border: .005rem solid #ddd;
      }
    }
    .block-text2 {
      max-width: 4rem;
      font-size: .15rem;
      color: #333;
      line-height: .26rem;
    }
    .block-text {
      display: flex;
      flex-flow: column;
      justify-content: flex-start;
      max-width: 4rem;
      .text-icon{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: .45rem;
        color: #333;
        margin-bottom: .38rem;

        img {
          margin-right: .23rem;
          width: .85rem;
          height: .85rem;
          border-radius: .18rem;
          border: .03rem solid rgba(255,255,255,0.5);
        }

      }
      .text-box {
        font-size: .15rem;
        color: #333;
        line-height: .26rem;
      }
    }
  }
  .block1 {
    background-image: linear-gradient(180deg, #C6EDFF 0%, #DEF5FF 50%, #7DB8FF 100%);
    .block-img {
      margin-right: .2rem;
    }
  }
  .block2 {
    background: #ECEDF1;
    .block-img {
      margin-left: .2rem;
    }
  }
  .block3 {
    background-image: linear-gradient(-31deg, #EDFAFF 2%, #FFFFFF 100%);
     .block-img {
      margin-right: .2rem;
    }
  }
  .block4 {
    background: #EFEDE1;
    .block-img {
      margin-left: .2rem;
    }
  }

  // 底部备案
  .footer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: .5rem;
    background: #333;
    font-size: .1rem;
    color: #fff;
    a, a:visited {
      color: #fff;
    }
  }
}
</style>
